import {useSortableTable, Table} from '@hm/fundamental'
import {Box} from '@mui/material'

import {CqdbMaterialsTableType, LabDataResults} from '../../types'

type Props = {
  data: CqdbMaterialsTableType
}

export const LabQualityResultTable: React.FC<Props> = ({data}) => {
  const config = useSortableTable<LabDataResults>(data.columns)
  return (
    <Box sx={{height: '100%', overflow: 'auto'}}>
      <Table config={config} data={data.rows} breakpoint="lg" data-cy="cqdb-materials-table" />
    </Box>
  )
}
